// src/features/landing/infrastructure/termsApiRepository.js

const API_BASE_URL = process.env.REACT_APP_RECRUIT_API_URL || 'http://localhost:8080';

/**
 * 약관 조회
 * @param {string} type - 약관 타입 (PRIVACY, SERVICE)
 * @returns {Promise<{id: number, type: string, title: string, content: string, version: string, updatedAt: string}>}
 */
async function getTermsByType(type) {
    const response = await fetch(
        `${API_BASE_URL}/api/terms/${type}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );

    if (!response.ok) {
        throw new Error('Failed to fetch terms');
    }

    return response.json();
}

export const termsRepository = {
    getTermsByType,
};
